import { generic } from "@/repositories/generic";
import { Price, Product } from "@/types/v2";

export const priceRepository = {
  list: async (): Promise<(Product & { prices: Price[] })[]> => {
    const products = (await generic.list<Product>("products")) as Product[];
    return await Promise.all(
      products
        .filter(
          (product) => product.active && product.metadata.active === "true"
        )
        .map(async (product) => {
          const prices = (await generic.list<Price>(
            `products/${product.id}/prices`
          )) as Price[];
          return {
            ...product,
            prices: prices.filter(
              (p) => p.active && p.metadata.active === "true"
            ),
          };
        })
    );
  },
};
